import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Util } from '../../../../../utils/util';
import { PixTransferReturnSucesso, PixTransferReturnSituacaoTransferencia } from '../../../models/transfer-return.model';
@Component({
	selector: 'app-pix-payment-key-favored-create-assignature-details',
	templateUrl: './details.component.html',
	styleUrls: ['./details.component.styl'],
})
export class PixPaymentKeyFavoredCreateDetailComponent {
	situacaoTransferencia: PixTransferReturnSituacaoTransferencia;
	valor: number;
	nome: string;
	dataContabil: Date;
	complemento: string;
	codigoTransacao: number;
	public receiptAvailable = true;
	private scheduledPayment = false;

	constructor(
		private router: Router,
		public dialogRef: MatDialogRef<PixPaymentKeyFavoredCreateDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.nome = data.nome;
		this.situacaoTransferencia = data.situacaoTransferencia;
		this.valor = data.valor;
		this.dataContabil = data.dataContabil;
		this.complemento = data.complemento;
		this.codigoTransacao = data.codigoTransacao;
		this.scheduledPayment = data.agendado;
	}

	getTitle(): string {
		switch (this.situacaoTransferencia) {
			case PixTransferReturnSituacaoTransferencia.AGUARDANDO_AUTORIZACAO:
				return this.scheduledPayment ? 'Pagamento agendado' : 'Pagamento gerado e pendente de aprovação';
			case PixTransferReturnSituacaoTransferencia.AUTORIZADA_AGUARDANDO_EFETIVACAO:
				return 'Pagamento agendado';
		}
	}

	getText(): string {
		switch (this.situacaoTransferencia) {
			case PixTransferReturnSituacaoTransferencia.AGUARDANDO_AUTORIZACAO:
				return `Após a autorização, ${Util.formatValue(this.valor)} será enviado via Pix para ${this.nome}`;
			case PixTransferReturnSituacaoTransferencia.AUTORIZADA_AGUARDANDO_EFETIVACAO:
				return `${Util.formatValue(this.valor)} será enviado via Pix para ${this.nome}`;
		}
	}

	newPix() {
		this.onClose(true);
		this.router.navigate(['pix']);
	}

	resume() {
		this.onClose(true);
		// this.router.navigate(['pix/comprovante/' + this.codigoTransacao + '/pix']);
		this.router.navigate(['pix/pagamento/favorecido/adicionar/comprovante']);
	}

	closeModal() {
		this.onClose(true);
		this.router.navigate(['pix']);
	}

	onClose(param: boolean) {
		this.dialogRef.close(param);
	}

	onConfirm = () => this.dialogRef.close(true);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-create/details/details.component.ts